import update from 'immutability-helper';
import { storage } from 'src/utilities/Storage';
import { ActionType, defaultAction } from '../types';

const auth = storage.get('auth', {});

export type PinState = {
  isShowPinModal: boolean;
  //TODO adjust the payload
  Pin?: 'string' | null;
};

const initialState: PinState = {
  isShowPinModal: false,
  Pin: auth.Pin,
};

const authReducer = (
  state = initialState,
  action: ActionType = defaultAction,
): PinState => {
  const { type, payload } = action;
  let newState: PinState;

  switch (type) {
    case 'SET_SHOW_PIN_MODAL':
      return {
        ...state,
        isShowPinModal: payload,
      };

    case 'SET_AUTH_PIN':
      newState = update(state, {
        Pin: {
          $set: payload,
        },
      });
      return newState;
    case 'CLEAR_AUTH_PIN':
      newState = update(state, {
        isShowPinModal: {
          $set: false,
        },
        Pin: {
          $set: null,
        },
      });
      return newState;
    default:
      return state;
  }
};

export default authReducer;
